import { CurrencyModel } from 'models/Settings/Financial/CurrencyModel';
import { MAX_SIGNIFICANT_DIGITS } from '../@constants/IntlNumberFormatterConstants';

export function intlNumberFormat(
  locale: string | undefined,
  currency: string | undefined,
  value: number
) {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(value);
  } catch (e) {
    return value;
  }
}

export function currencyFormat(
  locale: string | undefined,
  currency: Partial<CurrencyModel> | undefined,
  value: number | string,
  withoutCurrencySymbol?: boolean
) {
  try {
    return Boolean(currency)
      ? `${number_format(
          Number(value),
          currency?.decimal_places ?? 2,
          '.',
          currency?.thousand_separator ?? ' '
        )} ${withoutCurrencySymbol ? '' : getCurrencySymbol(locale!, currency!.code!)}`
      : value;

    // return Boolean(locale && currency)
    //   ? `${String(
    //       intlNumberFormatWithoutSymbol(
    //         locale!,
    //         currency!.code!,
    //         value,
    //         currency?.decimal_places ?? 2,
    //         currency?.decimal_places ?? 2
    //       )
    //     ).replace(/,/g, currency?.thousand_separator ?? ' ')} ${
    //       withoutCurrencySymbol ? '' : getCurrencySymbol(locale!, currency!.code!)
    //     }`
    //   : value;
  } catch (e) {
    return value;
  }
}

export const getCurrencySymbol = (locale: string, currency: string) =>
  (0)
    .toLocaleString(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      maximumSignificantDigits: MAX_SIGNIFICANT_DIGITS,
    })
    .replace(/\d/g, '')
    .trim();

export function intlNumberFormatWithoutSymbol(
  locale: string,
  currency: string,
  value: number | string,
  minimumFractionDigits?: number,
  maximumFractionDigits?: number
) {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: minimumFractionDigits ?? 2,
      maximumFractionDigits: maximumFractionDigits ?? 2,
    })
      .format(+value)
      .replace(getCurrencySymbol(locale, currency), '')
      .trim();
  } catch (e) {
    return value;
  }
}

function number_format(number: number, decimals = 0, decPoint = '.', thousandsSep = ',') {
  // Ensure the number is valid
  number = parseFloat(String(number));

  if (!isFinite(number)) return '0';

  // Round to specified decimals
  const fixed = number.toFixed(decimals);

  // Split into integer and fractional parts
  const [intPart, fracPart] = fixed.split('.');

  // Add thousand separators
  const intWithSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

  // Combine and return
  return decimals > 0 ? `${intWithSep}${decPoint}${fracPart}` : intWithSep;
}
